import React, { Component, PropTypes } from 'react';
import ImageLogo from '../../../../images/logo_ppa.svg';

export default class VideoRemoteControlButton extends Component {

  static contextTypes = {
    session: PropTypes.object.isRequired,
    setVideoState: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  };

  setVideoState (videoState) {
    this.context.setVideoState(videoState);
  }

  playPause () {
    const { session, i18n: _ } = this.context;
    const videoState = (session && session.videoState)
                       ? session.videoState : {};

    if (videoState.finished) {
      this.setVideoState({
        playing: false,
        started: false,
        finished: false
      });
      this.buttonLabel = _('Replay');
      setTimeout(() => {
        this.setVideoState({
          playing: true,
          started: true,
          finished: false
        });
        setTimeout(() => {
          this.buttonLabel = null;
        }, 500);
      }, 1000);
      return;
    }
    this.setVideoState({
      playing: !videoState.playing,
      started: true,
      finished: false
    });
  }

  seekVideo(seconds) {
    const { session } = this.context;
    const videoState = (session && session.videoState)
                       ? session.videoState : {};

    this.setVideoState({
      playing: videoState.playing,
      started: true,
      finished: false,
      seek: seconds,
      seekTimestamp: Date.now()
    });
  }

  render () {
    const { session, i18n: _ } = this.context;
    const videoState = (session && session.videoState)
                       ? session.videoState : {};
    let videoSlide = false;
    if (session &&
       (session.videoState &&
        Object.keys(session.videoState).length > 0)) {
      videoSlide = true;
    }

    if (videoSlide) {
      let videoButton;
      let playbackState = 'unstarted';
      if (videoState.playing) {
        playbackState = 'playing';
      }
      if (!videoState.playing && videoState.started) {
        playbackState = 'paused';
      }

      if (playbackState === 'unstarted' || playbackState === 'paused') {
        let buttonLabel = videoState.finished ? _('Replay') : _('Play');
        if (this.buttonLabel) {
          // We need to override the button label for when Replay
          // is clicked
          buttonLabel = this.buttonLabel;
        }
        videoButton = (
          <button
              key="play"
              className="btn teacher-remote-btn-video play"
              onClick={::this.playPause}>
            <span>
              <i className="glyphicon glyphicon-play"></i>
              {buttonLabel}
            </span>
          </button>
        );
      }

      if (playbackState === 'playing') {
        videoButton = (
          <button
              key="pause"
              className="btn teacher-remote-btn-video pause"
              onClick={::this.playPause}>
            <span>
              <i className="glyphicon glyphicon-pause"></i>
              {_('Pause')}
            </span>
          </button>
        );
      }

      const videoButtons = [];
      const disableSeek = !(playbackState === 'playing' || playbackState === 'paused');
      videoButtons.push((
        <button
          key="fast-backward"
          disabled={disableSeek}
          className="btn teacher-remote-btn-video fast-backward"
          onClick={this.seekVideo.bind(this, -15)}>
                  <span>
                    <i className="glyphicon glyphicon-fast-backward"></i>
                    {_('Rwd')}
                  </span>
        </button>
      ));
      videoButtons.push(videoButton);
      videoButtons.push((
        <button
          key="fast-forward"
          disabled={disableSeek}
          className="btn teacher-remote-btn-video fast-forward"
          onClick={this.seekVideo.bind(this, 15)}>
                  <span>
                    <i className="glyphicon glyphicon-fast-forward"></i>
                    {_('Fwd')}
                  </span>
        </button>
      ));

      return (
        <div className="btn-group">
          {videoButtons}
        </div>
      );
    }

    return (
      <span className="teacher-remote-btn-placeholder">
        <img src={ImageLogo}/>
      </span>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/videoRemoteControlButton.js